export const openAnotherMailbox = "h_UYzc";
export default {openAnotherMailbox};